<div
  class="shadow-item"
  role="button"
  tabindex="0"
  [attr.aria-label]="'Edit shadow: ' + item.name"
  (click)="edit.emit()"
  (keyup.enter)="edit.emit()"
>

  <!-- Score badge: purple cloud with value overlaid -->
  <div class="shadow-item__badge" aria-hidden="true">
    <img class="shadow-item__badge-icon" src="assets/icons/icon-shadow-cloud.svg" alt="" />
    <span class="shadow-item__badge-value">{{ item.stars }}</span>
  </div>
  <!-- <span class="sr-only">Score: {{ item.stars }}</span> -->

  <!-- Name + tags -->
  <div class="shadow-item__content">
    <p class="shadow-item__name">{{ item.name }}</p>
    <div class="shadow-item__tags" *ngIf="item.selectedTags?.length">
      <app-categories-and-tags-display
        [tags]="item.selectedTags"
        [selectedTags]="item.selectedTags"
      ></app-categories-and-tags-display>
    </div>
  </div>

</div>

<!-- Delete — sits outside the parchment card, to the right -->
<button
  *ngIf="showDeleteIcon"
  type="button"
  class="shadow-item__delete"
  aria-label="Delete shadow"
  (click)="$event.stopPropagation(); delete.emit()"
>
  <svg-icon src="assets/icons/icon-trash.svg" class="evergreen" [svgStyle]="{ 'width.px': 10, 'height.px': 11 }"></svg-icon>
</button>
